import { mdiAccount, mdiMapMarker } from "@mdi/js";
import Icon from "@mdi/react";
import { skipToken } from "@reduxjs/toolkit/query";
import { useEffect, useState } from "react";
import { useGetLocationsByNameQuery } from "../../Redux/Services/locationApi";
import { addLineToLocationLayer, clearLocationLayer, zoomToFeatureByXY } from "../Map/Layers/UsersLayers";
import { loadingSc } from "./AlertDiv";
import { warning } from "../../Utils/Alerts2";
import { zoomToFeatureByGeojson } from "../Map/Layers/TempLayer";

export default function ActiveUsers({ list }) {
  const today = new Date().toISOString().split("T")[0];

  const [visible, setVisible] = useState(false);
  const [selectedUser, setSelectedUser] = useState(false);
  const [tarih, setTarih] = useState(today);

  const { data, isLoading } = useGetLocationsByNameQuery(selectedUser ? { id: selectedUser.name, tarih } : skipToken);

  useEffect(() => {
    if (isLoading) {
      loadingSc(true);
    } else {
      loadingSc(false);
      if (data && data.rows) {
        const { geojson } = data.rows[0];
        if (!geojson) {
          clearLocationLayer();
          warning(`${tarih} tarihinde ${selectedUser.name} kullanıcısının konum geçmişi bulunamadı`);
        } else {
          addLineToLocationLayer(geojson);
          zoomToFeatureByGeojson(geojson);
        }
      }
    }
  }, [isLoading, data, selectedUser.name, tarih]);

  const handleClear = () => {
    clearLocationLayer();
    setSelectedUser(false);
  };

  return (
    <div className={visible ? "orangeBtn" : "darkOrangeBtn"}>
      <Icon
        path={mdiAccount}
        size={1.5}
        style={{ color: "black", cursor: "pointer" }}
        onClick={() => {
          setVisible(!visible);
        }}
      />
      {visible && (
        <div className="card map-overlay-popup users">
          <table className="table table-sm table-bordered">
            <tbody>
              <tr className="table-row">
                <td colSpan={4}>
                  <div className="d-flex justify-content-between kullanici-son">
                    Kullanıcıların Son Görülme Yerleri
                    <button
                      className="btn btn-danger btn-sm"
                      onClick={() => {
                        setVisible(!visible);
                      }}
                      style={{ fontSize: "10px" }}
                    >
                      X
                    </button>
                  </div>
                </td>
              </tr>
              <tr>
                <td colSpan={4}>
                  <div className="d-flex justify-content-between">
                    <input type="date" className="form-control form-control-sm d-inline w-50" value={tarih} onChange={(e) => setTarih(e.target.value)} />
                    <button onClick={handleClear} className="blueBtn w-25">
                      Temizle
                    </button>
                  </div>
                </td>
              </tr>
              <tr>
                <th>Konum</th>
                <th>Kullanıcı</th>
                <th>Tarih</th>
                <th>Geçmiş</th>
              </tr>
              {list.map((user, index) => {
                return (
                  <tr key={index} valign="middle">
                    <td>
                      <button className="btn btn-warning btn-sm" onClick={() => zoomToFeatureByXY(user.lon, user.lat)}>
                        <Icon
                          path={mdiMapMarker}
                          size={1}
                          style={{
                            padding: 0,
                            margin: 0,
                            color: "black",
                            cursor: "pointer",
                          }}
                        />
                      </button>
                    </td>
                    <td>{user.name}</td>
                    <td>{user.date}</td>
                    <td align="center">
                      <input type="radio" name="selectedUser" checked={selectedUser && selectedUser.name === user.name} onChange={() => setSelectedUser(user)} />
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
